import { useState } from "react";
import { useNavigate } from "react-router-dom";
import SearchBar from "../../components/SearchBar";
import { Button, MenuItem, Select, SelectChangeEvent, Switch, FormControlLabel, Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import NotificationsList from "../../features/manageNotifications/notificationsList";
import AddIcon from '@mui/icons-material/Add';
import React from "react";

const ManageNotifications = () => {

  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [type, setType] = React.useState('default');
  const [contentUpdatesEnabled, setContentUpdatesEnabled] = useState(true);
  const [activityUpdatesEnabled, setActivityUpdatesEnabled] = useState(true);
  const [broadcastEnabled, setBroadcastEnabled] = useState(true);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [pendingToggle, setPendingToggle] = useState<null | 'content' | 'activity' | 'broadcast'>(null);

  const handleToggle = (type: 'content' | 'activity' | 'broadcast', checked: boolean) => {
    if (!checked) {
      setPendingToggle(type);
      setConfirmOpen(true);
      return;
    }
    if (type === 'content') setContentUpdatesEnabled(true);
    if (type === 'activity') setActivityUpdatesEnabled(true);
    if (type === 'broadcast') setBroadcastEnabled(true);
  };

  const confirmDisable = () => {
    if (pendingToggle === 'content') setContentUpdatesEnabled(false);
    if (pendingToggle === 'activity') setActivityUpdatesEnabled(false);
    if (pendingToggle === 'broadcast') setBroadcastEnabled(false);
    setConfirmOpen(false);
    setPendingToggle(null);
  };

  const cancelDisable = () => {
    setConfirmOpen(false);
    setPendingToggle(null);
  };

  const handleTypeChange = (event: SelectChangeEvent) => {
    setType(event.target.value as string);
  };

  return (
    <>
      <div className="main_title">
        <h1>Notification  Management</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> -
          Notification  Management
        </p>
      </div>

      <div className="cards">
        <div className="table_header">
          <div className="left_s">
            <SearchBar
              searchTerm={searchTerm}
              setDebouncedSearchTerm={setSearchTerm}
              placeholder="Search..."
            />
            {/* <div className="form">
              <div className="control_group">
                <Select
                  fullWidth
                  value={type}
                  onChange={handleTypeChange}
                >
                  <MenuItem disabled value="default">Select Type</MenuItem>
                  <MenuItem value="broadcast">Broadcast</MenuItem>
                  <MenuItem value="email">Email</MenuItem>
                </Select>
              </div>
            </div> */}
          </div>
          <div className="right_s">
            <div className="form" style={{ display: 'flex', gap: 16, alignItems: 'center', flexWrap: 'wrap' }}>
              <FormControlLabel
                control={<Switch checked={contentUpdatesEnabled} onChange={(e) => handleToggle('content', e.target.checked)} />}
                label="Content-based changes & updates"
              />
              <FormControlLabel
                control={<Switch checked={activityUpdatesEnabled} onChange={(e) => handleToggle('activity', e.target.checked)} />}
                label="Activity-based updates"
              />
              <FormControlLabel
                control={<Switch checked={broadcastEnabled} onChange={(e) => handleToggle('broadcast', e.target.checked)} />}
                label="Broadcast notification"
              />
            </div>
            <Button className="btn btn_primary" onClick={() => navigate("/manage-notifications/add")}><AddIcon /> Add Notification</Button>
          </div>
        </div>

        <NotificationsList />
      </div>

      <Dialog open={confirmOpen} onClose={cancelDisable} maxWidth="xs" fullWidth>
        <DialogTitle>Disable notifications</DialogTitle>
        <DialogContent>
          <p>
            This will disable <b>{pendingToggle === 'content' ? 'Content-based changes & updates' : pendingToggle === 'activity' ? 'Activity-based updates' : 'Broadcast notification'}</b> for all users. You can re-enable it anytime.
          </p>
        </DialogContent>
        <DialogActions>
          <Button onClick={cancelDisable}>Cancel</Button>
          <Button className="btn btn_danger" onClick={confirmDisable}>Disable</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ManageNotifications;
